/**
 * Opens the nearest Dialog and plays the iFrame automatically if available.
 * @param {string} trigger Custom class trigger Eg:"js-modal-video"
 * @returns {string} - Opens the nearby dialog and plays the iFrame if available
 */
export function openDialog(trigger) {
    const dialog = trigger.parentElement?.querySelector("dialog");
    if (!dialog) return;

    dialog.showModal();

    const closeBtn = dialog.querySelector("span.absolute");
    const iframe = dialog.querySelector("iframe");

    dialog.scroll({ top: 0 });

    let src = "";

    if (iframe) {
        src = iframe.getAttribute("src") || "";

        let autoplaySrc = src;

        if (!autoplaySrc.includes("autoplay=1")) {
            autoplaySrc += (autoplaySrc.includes("?") ? "&" : "?") + "autoplay=1";
        }

        iframe.setAttribute("src", autoplaySrc);
    }

    if (closeBtn) {
        closeBtn.addEventListener(
            "click",
            () => {
                dialog.close();

                if (iframe) {
                    iframe.setAttribute("src", "");
                    iframe.setAttribute("src", src);
                }
            },
            { once: true }
        );
    }
}


document.addEventListener("click", (e) => {
    const trigger = e.target.closest(".js-dialog-video");
    if (!trigger) return;
    e.preventDefault();
    openDialog(trigger);
});